'use strict';
module.exports = function subscriptionIsActive(subscription) {
	const activeStates = ['trial', 'active', 'cancelled', 'overdue'];
	return !!(subscription && subscription.status && activeStates.includes(subscription.status));
};
